import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import styled from 'styled-components';
import TMMButton from '#/common/components/TMMButton';
import React from 'react';

interface ErrorPageProps {
  svg: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  message: string;
  buttonLabel: string;
  onButtonClick: () => void;
  svgContainerStyle?: React.CSSProperties;
}

const ErrorMsg = styled(NuvoText)`
  text-align: center;
  font-weight: 600;
  font-size: 24px;
`;

const ErrorPage: React.FC<ErrorPageProps> = ({ svg: SvgComponent, message, buttonLabel, onButtonClick, svgContainerStyle }) => {
  return (
    <NuvoBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      flex="1"
      gap="24px">
      <div style={svgContainerStyle}>
        <SvgComponent />
      </div>
      <ErrorMsg type="large">
        {message}
      </ErrorMsg>
      <TMMButton type="submit" label={buttonLabel} onClick={onButtonClick} />
    </NuvoBox>
  );
};

export default React.memo(ErrorPage);
